export default __webpack_public_path__ + "static/media/testimg.3b290d8b.jpg";